import { render, staticRenderFns } from "./TableDetailMissingPurchases.vue?vue&type=template&id=42f23964&"
import script from "./TableDetailMissingPurchases.vue?vue&type=script&lang=js&"
export * from "./TableDetailMissingPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports